import React, { Component } from "react";

//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import CardEntidadV2 from "./CardEntidadV2";
import pagoServicioServiceV2 from "../../../services/pagoServicios/pagoServicioServiceV2";
import history from "../login/history";
import Select from "react-select";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import ConfigService from "../../../services/configuracion/ConfigService";
import PopupEntidadServicioV2 from "./PopupEntidadServicioV2";

export default class PagoServicioCabal extends Component {
  constructor(props) {
    super(props);
    this.getCuentasSocio = this.getCuentasSocio.bind(this);
    this.getOptionsCuentas = this.getOptionsCuentas.bind(this);

    this.state = {
      cuentasOrigen: [],
      optionsCuentas: [],
      selectedOption: "",
      rubros: [],
      selectedRubro: "",
      valorRubroSelected: undefined,
      inputEntidad: "",
      loading: false,
      message: "",
      entidadesFiltrado: [],
      servicios: [],
      entidades: [],
      itemSelected: [],
      valor: "",
      pathEntidad: "",
      servicioSearch: undefined,
      logo:""
    };
  }

  componentDidMount() {
    this.getServiciosDisponiblesV2();
    this.limpiarSessionStorage();
  }

  limpiarSessionStorage(){
    sessionStorage.removeItem("servicio");
    sessionStorage.removeItem("nombre");
    sessionStorage.removeItem("img");
    sessionStorage.removeItem("entidad");
    sessionStorage.removeItem('networkParticipantCode');
    sessionStorage.removeItem('codigoEntidad');
    sessionStorage.removeItem("network");
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  getOptionsCuentas(item) {
    var options = [];

    for (var i = 0; i < item.length; i++) {
      options.push({
        value: item[i].cuenta,
        label:
          item[i].cuenta +
          "-" +
          item[i].tipoDeCuenta +
          "-" +
          " Saldo: " +
          item[i].saldoActual + " " +
          item[i].moneda +
          ".",
      });
    }
    this.setState({ optionsCuentas: options });
  }


  getCuentasSocio() {
    trackPromise(
      pagoServicioServiceV2.getCuentasSocio()
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codRespuesta === '000') {
            this.setState({ cuentasOrigen: jsonData.respuestaDetalles });
            this.getOptionsCuentas(jsonData.respuestaDetalles);
          }
        },
          error => {
            const resMessage = error.codDescripcion;
            this.setState({
              loading: false,
              message: resMessage
            });
            //  this.modalControl.click();
          }
        ));
  }

  compareV2(a, b) {
    const bandA = a.paymentEntityName.toUpperCase();
    const bandB = b.paymentEntityName.toUpperCase();

    let comparison = 0;
    if (bandA > bandB) {
      comparison = 1;
    } else if (bandA < bandB) {
      comparison = -1;
    }
    return comparison;
  }

  getServiciosDisponiblesV2(){
    let todoEntidad = [];
    trackPromise(
      pagoServicioServiceV2.listarServicios()
      .then( (response) =>{
        if( response.status === 200 ){
          let data = JSON.parse(JSON.stringify(response.data));
          if( data.codigo === 0 ){
            let entidades = JSON.parse( JSON.stringify(data.datos.data) );
            todoEntidad = entidades;
            todoEntidad.sort(this.compareV2);
            this.setState({ entidades: todoEntidad, entidadesFiltrado: todoEntidad });
          }else{
            Popup.queue(this.notifiPopup("Error", data.mensaje));
          }
        }else{
          Popup.queue(this.notifiPopup("Error", 'Error al obtener los servicios disponibles. Por favor intente recargar la página.'));
        }
      })
      .catch( (err) =>{
        Popup.queue(this.notifiPopup("Error", 'Error al obtener los servicios disponibles. Por favor intente recargar la página.'));
        console.log('errorListarServiciosV2');
        console.log(err);
      })
    )  
  }




  handleChangeSelector = (selectedOption) => {
    this.setState({ selectedOption });
    this.getServiciosDisponiblesV2();

  };


  // handleChangeSelectorRubro = (selectedRubro) => {


  //   var rubro = selectedRubro.value
  //   this.setState({ selectedRubro, valorRubroSelected: rubro, entidadesFiltrado: this.selectorRubro(rubro) });
  //   // this.setState({ entidadesFiltrado: this.selectorRubro(rubro) });

  // };


  // selectorRubro = (rubro) => {

  //   var filtrado = [];
  //   var filtradoServ = [];
  //   var iter = 0;
  //   var buscar = document.getElementById("inputEntidad").value

  //   if (rubro === undefined && buscar === "")
  //     return this.state.entidades;
  //   if (rubro === undefined && buscar !== "") {

  //     for (var i = 0; i < this.state.entidades.length; i++) {
  //       var datos = JSON.parse(JSON.stringify(this.state.entidades[i]));

  //       if (datos.desEntidad.toUpperCase().includes(buscar.toUpperCase())) {

  //         filtradoServ[iter] = datos;
  //         iter++;

  //       }
  //     }
  //     filtrado = filtradoServ;
  //     return filtrado;
  //   }


  //   for (var x = 0; x < this.state.entidades.length; x++) {
  //     var datoFiltrado = JSON.parse(JSON.stringify(this.state.entidades[x]));
  //     for (var j = 0; j < datoFiltrado.servicio.length; j++) {
  //       var datoServicio = JSON.parse(JSON.stringify(datoFiltrado.servicio[j]));
  //       if (datoServicio.rubro.toUpperCase() === rubro.toUpperCase()) {

  //         filtrado[iter] = datoFiltrado;
  //         iter++;
  //         break;
  //       }

  //     }
  //   }


  //   if (buscar !== "") {
  //     var filtradoServicios = [];
  //     var iterador = 0;


  //     for (var k = 0; k < filtrado.length; k++) {
  //       var dat = JSON.parse(JSON.stringify(filtrado[k]));

  //       if (dat.desEntidad.toUpperCase().includes(buscar.toUpperCase())) {

  //         filtradoServicios[iterador] = dat;
  //         iterador++;

  //       }
  //     }
  //     filtrado = filtradoServicios;
  //   }


  //   return filtrado;

  // };

  handleChangeServicio = (servicio) => {
    if (servicio === "" && this.state.valorRubroSelected === undefined) {
      this.setState({ entidadesFiltrado: this.state.entidades, servicioSearch: undefined });
    }
    else {
      if( servicio !== "" ){
        this.setState({entidadesFiltrado:this.selectorServicio(servicio) , servicioSearch : servicio});
      }
      // if (servicio !== "" && this.state.valorRubroSelected === undefined) {
      //   this.setState({ entidadesFiltrado: this.selectorServicio(servicio), servicioSearch: servicio });
      // }
      // if (servicio !== "" && this.state.valorRubroSelected !== undefined) {

      //   this.setState({ entidadesFiltrado: this.selectorServicioRubro(servicio), servicioSearch: servicio });
      // }
      // if (servicio === "" && this.state.valorRubroSelected !== undefined) {

      //   this.setState({ entidadesFiltrado: this.selectorRubro(this.state.valorRubroSelected), servicioSearch: undefined });
      // }
    }
  };


  selectorServicio = (serv) => {
    var filtradoServ = [];
    var iter = 0;
    for (var i = 0; i < this.state.entidades.length; i++) {
      var datos = JSON.parse(JSON.stringify(this.state.entidades[i]));
      if (datos.paymentEntityName.toUpperCase().includes(serv.toUpperCase())) {
        filtradoServ[iter] = datos;
        iter++;
      }
    }
    return filtradoServ;
  };

  selectorServicioRubro = (serv) => {
    var filtradoServ = [];
    var iter = 0;
    var filtradoRubros = this.selectorRubro(this.state.valorRubroSelected);
    for (var i = 0; i < filtradoRubros.length; i++) {
      var datos = JSON.parse(JSON.stringify(filtradoRubros[i]));

      if (datos.desEntidad.toUpperCase().includes(serv.toUpperCase())) {

        filtradoServ[iter] = datos;
        iter++;

      }
    }

    return filtradoServ;

  };

  selectorValueV2 = (dataFromChild, nombreEntidad, path) => {
    this.setState({
      valor: dataFromChild,
      itemSelected: nombreEntidad,
    });

    this.state.servicios = dataFromChild;
    this.state.pathEntidad = path;

    if (dataFromChild.length === 1) {
      this.selectorValuePopUpV2(null,dataFromChild[0].paymentServiceName,dataFromChild[0].paymentServiceId,dataFromChild[0].paymentEntityId,nombreEntidad,dataFromChild[0].networkParticipantCode,dataFromChild[0].network);
      return;
    }
    sessionStorage.setItem('img',path);
    sessionStorage.setItem('entidad',nombreEntidad);
    this.modalControl.click();
  };

  selectorValuePopUpV2 = (dataFromChild, desServicio, codigoServicio, codigoEntidad, entidad,networkParticipantCode,network) => {
    sessionStorage.setItem("servicio", codigoServicio);
    sessionStorage.setItem("nombre", desServicio);
    sessionStorage.setItem("codigoEntidad",codigoEntidad);
    sessionStorage.setItem("network",network);
    sessionStorage.setItem("entidad", entidad);
    sessionStorage.setItem('networkParticipantCode',networkParticipantCode);
    // history.push('/dimo');
    history.push(ConfigService.getPathByName("cabal")?.url);
    window.location.reload();

  };

  render() {

    var ent = this.state.entidadesFiltrado;
    
    return (
      <div className="content-wrapper">
        <Titulo texto="Pago de Servicios Publicos y Privados - CABAL" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-header" style={{ paddingBottom: 20 }}>
                    <div className="row">
                      <div className="col-md-2">
                        <br />
                        <b>Buscador Avanzado:</b>
                      </div>
                      {/* <div className="col-md-5">
                        <label className="input-label">Categoría del servicio</label>
                        <Select key={this.state.selectedRubro}
                          value={this.state.selectedRubro}
                          onChange={this.handleChangeSelectorRubro}
                          options={this.state.rubros}
                          placeholder="TODOS"
                          noOptionsMessage={() => 'SIN DATOS'}
                        />
                      </div> */}
                      <div className="col-md-10">
                        <label className="input-label">Entidad</label>
                        <input id="inputEntidad" type="text" className="input-box form-control" name="inputEntidad"
                          onChange={(e) => { this.handleChangeServicio(e.currentTarget.value) }}
                        />
                      </div>
                    </div>
                  </div>
                  {/* CONTENEDOR DE SERVICIOS - INI*/}
                  <div className="card-body">
                    <div className="col-md-12 pago-servicio-listado">
                      <div className="row" >
                        {ent.map(elemento =>
                          <CardEntidadV2 key={elemento.paymentServices.paymentEntityId}
                            img={elemento.paymentEntityLogo} label={elemento.paymentEntityName} codigo={elemento.paymentServices.paymentEntityId}
                            selectorValue={this.selectorValueV2.bind(this)}
                            itemSelected={elemento}
                          />
                        )}
                      </div>
                    </div>
                    {/* CONTENEDOR DE SERVICIOS - FIN*/}
                  </div>
                </div>
              </div>
            </div>
            <a ref={(a) => (this.modalControl = a)}
              href="#" className="pago-servicio-caja-link" data-toggle="modal" data-target="#modal-entidad">
              <PopupEntidadServicioV2 idModal="modal-entidad" disponibles={this.state.servicios} titulo={this.state.itemSelected} imagen={this.state.pathEntidad} selectorValuePopUp={this.selectorValuePopUpV2.bind(this)} />
            </a>
          </div>
        </section>
      </div>

    );
  }
}